module.exports = __webpack_public_path__ + "img/home_select.8c247cbb.png";